import { useTenantSettings } from "stores/tenantSettings"

export default function useTenantCurrency() {
    const { tenantSettings } = useTenantSettings()
    return tenantSettings?.defaultCurrency || null
}
